import React, { useState } from "react";

import { ShieldCheck, Pill,  } from 'lucide-react';

const C = {
  purple: "var(--primary)",
  purpleLight: "#F0EEFF",
  purpleBg: "#EEE9FF",
  red: "#E74C3C",
  redLight: "#FFF0F0",
  green: "#27AE60",
  greenLight: "#E8F8EE",
  greenBg: "#F0FFF6",
  blue: "#3498DB",
  blueBg: "#E8F4FD",
  yellow: "#F39C12",
  yellowBg: "#FFF8E1",
  bg: "#F4F4F8",
  white: "#FFFFFF",
  text: "#111111",
  sub: "#888888",
  border: "#EEEEEE",
  dark: "#555555",
};

/* ── icons ── */
const Icon = ({ d, stroke = C.dark, fill = "none", size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={fill} {...rest}>
    <path d={d} stroke={stroke} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const CheckCircle = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill={C.green}>
    <circle cx="8" cy="8" r="8" />
    <path d="M4.5 8.5l2.5 2.5 4.5-4.5" stroke="#fff" strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const PhoneIcon = ({ color = C.white, size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill={color}>
    <path d="M14.5 11.1l-3.2-.4a1 1 0 00-.8.3l-2.3 2.3C5.3 11.9 3.1 9.8 1.8 7l2.3-2.3A1 1 0 004.4 4L4 .8A1 1 0 003 0H1C.4 0 0 .5 0 1 0 9.3 6.7 16 15 16c.5 0 1-.4 1-1v-2a1 1 0 00-.9-.9z" />
  </svg>
);

const LocationPin = () => (
  <svg width="20" height="26" viewBox="0 0 20 26" fill="none">
    <path d="M10 0C6.1 0 3 3.1 3 7c0 5.3 7 13 7 13s7-7.7 7-13c0-3.9-3.1-7-7-7z" fill="var(--primary)q" />
    <circle cx="10" cy="7" r="2.5" fill="#fff" />
  </svg>
);

const ShieldIcon = () => (
  <svg width="15" height="15" viewBox="0 0 18 20" fill="none">
    <path d="M9 1L1 4v6c0 5 3.5 9.7 8 11 4.5-1.3 8-6 8-11V4L9 1z" stroke="var(--primary)" strokeWidth="1.5" fill="none" />
    <path d="M5 10l3 3 5-5" stroke="var(--primary)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
  </svg>
);

const LockIcon = () => (
  <svg width="15" height="15" viewBox="0 0 16 18" fill="none">
    <rect x="2" y="7" width="12" height="10" rx="2" stroke="var(--primary)" strokeWidth="1.5" fill="none" />
    <path d="M5 7V5a3 3 0 016 0v2" stroke="var(--primary)" strokeWidth="1.5" strokeLinecap="round" fill="none" />
    <circle cx="8" cy="12" r="1.2" fill="var(--primary)" />
  </svg>
);

const PeopleIcon = () => (
  <svg width="15" height="14" viewBox="0 0 20 14" fill="none">
    <circle cx="6" cy="5" r="3.5" stroke={C.purple} strokeWidth="1.5" fill="none" />
    <circle cx="14" cy="5" r="3.5" stroke={C.purple} strokeWidth="1.5" fill="none" />
    <path d="M1 13c0-2.8 2.2-5 5-5" stroke={C.purple} strokeWidth="1.5" strokeLinecap="round" fill="none" />
    <path d="M14 8c2.8 0 5 2.2 5 5" stroke={C.purple} strokeWidth="1.5" strokeLinecap="round" fill="none" />
  </svg>
);

const ClockIcon = ({ color = C.purple, size = 26 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="2" />
    <path d="M12 7v5l3.5 3.5" stroke={color} strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const BellIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
    <path d="M18 8a6 6 0 00-12 0c0 7-3 9-3 9h18s-3-2-3-9" stroke="#555" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M13.73 21a2 2 0 01-3.46 0" stroke="#555" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const DotsIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="5" r="1.5" fill="#555" />
    <circle cx="12" cy="12" r="1.5" fill="#555" />
    <circle cx="12" cy="19" r="1.5" fill="#555" />
  </svg>
);

const HomeIcon = ({ active }) => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill={active ? C.purple : "none"}>
    <path d="M3 10.5L12 2l9 8.5V21a1 1 0 01-1 1H15v-6H9v6H4a1 1 0 01-1-1V10.5z"
      stroke={active ? C.purple : C.sub} strokeWidth="1.6" fill={active ? C.purple : "none"} />
  </svg>
);

const GridIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
    <rect x="3" y="3" width="7" height="7" rx="1.5" stroke={C.sub} strokeWidth="1.6" />
    <rect x="14" y="3" width="7" height="7" rx="1.5" stroke={C.sub} strokeWidth="1.6" />
    <rect x="3" y="14" width="7" height="7" rx="1.5" stroke={C.sub} strokeWidth="1.6" />
    <rect x="14" y="14" width="7" height="7" rx="1.5" stroke={C.sub} strokeWidth="1.6" />
  </svg>
);

const WalletIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
    <rect x="2" y="6" width="20" height="14" rx="3" stroke={C.sub} strokeWidth="1.6" />
    <path d="M7 6V5a5 5 0 0110 0v1" stroke={C.sub} strokeWidth="1.6" strokeLinecap="round" />
    <line x1="16" y1="13" x2="16" y2="13" stroke={C.sub} strokeWidth="2.5" strokeLinecap="round" />
  </svg>
);

const UserIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="7" r="4" stroke={C.sub} strokeWidth="1.6" />
    <path d="M4 20c0-4.4 3.6-8 8-8s8 3.6 8 8" stroke={C.sub} strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

const ChevronRight = ({ color = C.purple, size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 12 20" fill="none">
    <path d="M2 2l8 8-8 8" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const BackIcon = () => (
  <svg width="10" height="16" viewBox="0 0 10 16" fill="none">
    <path d="M8 2L2 8l6 6" stroke="#333" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

/* ── Ambulance SVG ── */
const AmbulanceSVG = () => (
  <svg width="100" height="70" viewBox="0 0 100 70" fill="none">
    <rect x="5" y="22" width="65" height="32" rx="5" fill="#E74C3C" />
    <rect x="62" y="14" width="30" height="40" rx="5" fill="#C0392B" />
    <rect x="66" y="18" width="18" height="14" rx="2" fill="#AED6F1" />
    <rect x="8" y="36" width="65" height="6" fill="#C0392B" opacity=".45" />
    <rect x="22" y="30" width="16" height="5" rx="1.5" fill="#fff" />
    <rect x="28" y="24" width="4.5" height="17" rx="1.5" fill="#fff" />
    <circle cx="22" cy="56" r="8" fill="#2C3E50" />
    <circle cx="22" cy="56" r="4" fill="#BDC3C7" />
    <circle cx="70" cy="56" r="8" fill="#2C3E50" />
    <circle cx="70" cy="56" r="4" fill="#BDC3C7" />
    <rect x="20" y="13" width="10" height="8" rx="2.5" fill="#E74C3C" />
    <rect x="35" y="13" width="10" height="8" rx="2.5" fill="#3498DB" />
    {/* siren flash */}
    <circle cx="25" cy="17" r="2" fill="#fff" opacity=".7" />
    <circle cx="40" cy="17" r="2" fill="#fff" opacity=".7" />
  </svg>
);

/* ── Mini Map ── */
const MiniMap = () => (
  <svg width="130" height="86" viewBox="0 0 130 86" style={{ borderRadius: 12 }}>
    <rect width="130" height="86" fill="#E8F5E9" />
    <rect x="0" y="38" width="130" height="9" fill="#fff" opacity=".85" />
    <rect x="60" y="0" width="9" height="86" fill="#fff" opacity=".85" />
    <rect x="20" y="20" width="90" height="6" fill="#fff" opacity=".5" />
    <path d="M18 60 Q52 60 64 44 Q76 28 104 32" stroke={C.purple} strokeWidth="2.2" strokeDasharray="5,3.5" fill="none" />
    <g transform="translate(10,52)">
      <rect x="0" y="0" width="16" height="10" rx="2.5" fill={C.red} />
      <circle cx="4" cy="11" r="2.5" fill="#333" />
      <circle cx="12" cy="11" r="2.5" fill="#333" />
      <rect x="4" y="2" width="6" height="4" rx="1" fill="#fff" opacity=".8" />
    </g>
    <circle cx="104" cy="32" r="8" fill={C.purple} opacity=".9" />
    <circle cx="104" cy="32" r="3.5" fill="#fff" />
  </svg>
);

/* ── Trust Badge ── */
const TrustBadge = ({ icon, label, sub, border }) => (
  <div style={{ display: "flex", alignItems: "center", gap: 8, flex: 1, padding: "0 10px", borderLeft: border ? `1px solid ${C.border}` : "none" }}>
    <div style={{ width: 34, height: 34, background: C.purpleBg, borderRadius: 9, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
      {icon}
    </div>
    <div>
      <div style={{ fontSize: 11, fontWeight: 700, color: C.text }}>{label}</div>
      <div style={{ fontSize: 10, color: C.sub, marginTop: 1 }}>{sub}</div>
    </div>
  </div>
);

/* ── Category Chip ── */
const categories = [
  { label: "Medical\nEmergency", bg: "#FFE8EA", icon: (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
      <path d="M22.1 4.9a7 7 0 00-9.9 0L12 5.9l-.2-.2a7 7 0 00-9.9 9.9l.2.2L12 25.6l9.9-9.8.2-.2a7 7 0 000-10.7z" fill={C.red} />
      <path d="M12 9v8M8 13h8" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
    </svg>
  )},
  { label: "Accident\nInjury", bg: "#FFF8E1", icon: (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
      <circle cx="13" cy="4" r="3.5" fill={C.yellow} />
      <path d="M13 7.5c-2.5 0-4.5 2-4.5 4.5v5l-2.5 5h14l-2.5-5v-5c0-2.5-2-4.5-4.5-4.5z" fill={C.yellow} />
      <line x1="8.5" y1="17" x2="5.5" y2="23" stroke={C.yellow} strokeWidth="2.2" strokeLinecap="round" />
    </svg>
  )},
  { label: "Pregnancy\nEmergency", bg: "#E0F5EC", active: true, icon: (
    <svg width="24" height="28" viewBox="0 0 24 28" fill="none">
      <circle cx="12" cy="5" r="4" fill={C.green} />
      <path d="M8 11c0 2 1.5 5 4 5s4-3 4-5v5a4 4 0 01-8 0v-5z" fill={C.green} />
      <ellipse cx="15" cy="16" rx="3.5" ry="3.5" fill="#E0F5EC" stroke={C.green} strokeWidth="1.5" />
    </svg>
  )},
  { label: "Non-Emergency\nTransport", bg: C.blueBg, icon: (
    <svg width="28" height="22" viewBox="0 0 28 22" fill="none">
      <rect x="1" y="6" width="26" height="14" rx="3" stroke={C.blue} strokeWidth="1.5" fill="none" />
      <rect x="5" y="3" width="18" height="5" rx="1.5" fill={C.blue} opacity=".28" />
      <line x1="8" y1="13" x2="20" y2="13" stroke={C.blue} strokeWidth="2" strokeLinecap="round" />
      <line x1="8" y1="16.5" x2="14" y2="16.5" stroke={C.blue} strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  )},
  { label: "Other\nReason", bg: C.purpleLight, icon: (
    <div style={{ display: "flex", gap: 4, alignItems: "center" }}>
      {[0,1,2].map(i => <div key={i} style={{ width: 6, height: 6, borderRadius: "50%", background: C.purple }} />)}
    </div>
  )},
];

/* ── Track Step ── */
const TrackStep = ({ label, time, done, active, last }) => (
  <div style={{ display: "flex", flexDirection: "column" }}>
    <div style={{ display: "flex", alignItems: "center", gap: 7 }}>
      <div style={{ flexShrink: 0, width: 18, height: 18, borderRadius: "50%", background: done || active ? C.purple : "transparent", border: done || active ? "none" : `2px solid #ccc`, display: "flex", alignItems: "center", justifyContent: "center" }}>
        {(done || active) && <svg width="10" height="8" viewBox="0 0 10 8"><path d="M1 4l3 3L9 1" stroke="#fff" strokeWidth="1.6" fill="none" strokeLinecap="round" strokeLinejoin="round" /></svg>}
      </div>
      <div style={{ flex: 1, fontSize: 10.5, fontWeight: active ? 700 : 600, color: active ? C.purple : done ? C.text : "#aaa" }}>{label}</div>
      <div style={{ fontSize: 10, color: C.sub, whiteSpace: "nowrap" }}>{time}</div>
      {done && !active && <CheckCircle size={15} />}
    </div>
    {!last && (
      <div style={{ marginLeft: 8, width: 2, height: 9, background: active || done ? (active ? C.purple : "#ccc") : "#ddd", marginBottom: 0 }} />
    )}
  </div>
);


const trustHighlights = [
  {
    Icon: ShieldIcon,
    title: 'Secure & Regulated',
    subtitle: 'Verified providers',
  },
  {
    Icon: LockIcon,
    title: '24/7 Available',
    subtitle: 'Always ready to help',
  },
  {
    Icon: PeopleIcon,
    title: 'Trusted Network',
    subtitle: 'Across your region',
  },
];

const styles = {
  trustStrip: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: 6,
    marginBottom: 10,
    marginTop: 8,
    background: "#ffffff",
    border: "1px solid #eceef1",
    borderRadius: 999,
    padding: "6px 8px",
    overflowX: "auto",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
  },
  trustTrack: {
    display: "flex",
    alignItems: "center",
    width: "max-content",
    gap: 6,
  },
  trustItem: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    minWidth: 142,
  },
  trustItemIconWrap: {
    width: 24,
    height: 24,
    borderRadius: "50%",
    border: "1px solid #eceef1",
    background: "#ffffff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  trustItemCopy: {
    display: "flex",
    flexDirection: "column",
    lineHeight: 1.15,
  },
  trustItemTitle: {
    fontSize: 11,
    color: "#3D3A52",
    fontWeight: 700,
    whiteSpace: "nowrap",
  },
  trustItemSubtitle: {
    fontSize: 9,
    color: "#A0A0B2",
    fontWeight: 500,
    whiteSpace: "nowrap",
  },
  trustStripDivider: {
    width: 1,
    height: 20,
    background: "#d6d2e7",
    flexShrink: 0,
  },
};

function TrustStripe() {
  const trustStripRef = React.useRef(null);
  const [isTrustStripPaused, setIsTrustStripPaused] = React.useState(false);
  React.useEffect(() => {
    const strip = trustStripRef.current;
    if (!strip || isTrustStripPaused) return;
    const interval = setInterval(() => {
      const resetPoint = strip.scrollWidth / 2;
      if (resetPoint <= 0) return;
      if (strip.scrollLeft >= resetPoint) {
        strip.scrollLeft -= resetPoint;
      }
      strip.scrollBy({ left: 1, behavior: 'auto' });
    }, 24);
    return () => clearInterval(interval);
  }, [isTrustStripPaused]);
  return (
    <div
      ref={trustStripRef}
      
      style={styles.trustStrip}
      onMouseEnter={() => setIsTrustStripPaused(true)}
      onMouseLeave={() => setIsTrustStripPaused(false)}
      onTouchStart={() => setIsTrustStripPaused(true)}
      onTouchEnd={() => setIsTrustStripPaused(false)}
    >
      <div style={styles.trustTrack}>
        {[...trustHighlights, ...trustHighlights].map((item, index, list) => {
          const Icon = item.Icon;
          return (
            <React.Fragment key={`${item.title}-${index}`}>
              <div style={styles.trustItem}>
                <div style={styles.trustItemIconWrap}>
                  <Icon size={13} color="var(--primary)" />
                </div>
                <div style={styles.trustItemCopy}>
                  <span style={styles.trustItemTitle}>{item.title}</span>
                  <span style={styles.trustItemSubtitle}>{item.subtitle}</span>
                </div>
              </div>
              {index < list.length - 1 && <div style={styles.trustStripDivider}></div>}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}

/* ══════════ MAIN ══════════ */
export default function EmergencyResponseUI() {
  const [activeNav, setActiveNav] = useState("home");

  return (<>
  {/* Body  */}
  <div style = {{width : "100%" ,alignItems : "center", display : "flex", height : "100vh", justifyContent: "center"}}>
      <div style = {{alignItems : "center", textAlign : "center"}}>
          <h3 >Hi thanks for using QUREO, this feature will be available shortly. Thanks!!!!!!</h3>

         <a href= "/home">return home</a>
        
      </div>
     
</div>
    </>
  );
}
